import { render, staticRenderFns } from "./commonSOP.vue?vue&type=template&id=06f51c88&scoped=true&"
import script from "./commonSOP.vue?vue&type=script&lang=js&"
export * from "./commonSOP.vue?vue&type=script&lang=js&"
import style0 from "./commonSOP.vue?vue&type=style&index=0&id=06f51c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f51c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06f51c88')) {
      api.createRecord('06f51c88', component.options)
    } else {
      api.reload('06f51c88', component.options)
    }
    module.hot.accept("./commonSOP.vue?vue&type=template&id=06f51c88&scoped=true&", function () {
      api.rerender('06f51c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mass/SOP/components/commonSOP.vue"
export default component.exports